import React from "react";
import { outlineFocus } from "utils";

function operationStatus(props) {
  return (
    <div className="en_advence">
      <div className="sub_title">Backup Notifications</div>
      <div className="en_inpt just_flex">
        <div
          className="check"
          onChange={() => props.toggleNotificationOperationStatus("onSuccess")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.operationStatus.onSuccess && window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="email_notification_1"
            defaultChecked={props.operationStatus.onSuccess}
            onFocus={() => {
              outlineFocus("email_notification_1_label", 1);
            }}
            onBlur={() => {
              outlineFocus("email_notification_1_label", 0);
            }}
            tabIndex={0}
          />
          <label
            htmlFor="email_notification_1"
            id="email_notification_1_label"
          />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleNotificationOperationStatus("onSuccess")}
        >
          Notify when backup succeeds
        </p>
      </div>
      <div className="en_inpt just_flex">
        <div
          className="check"
          onChange={() => props.toggleNotificationOperationStatus("onFailure")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.operationStatus.onFailure && window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="email_notification_2"
            defaultChecked={props.operationStatus.onFailure}
            onFocus={() => {
              outlineFocus("email_notification_2_label", 1);
            }}
            onBlur={() => {
              outlineFocus("email_notification_2_label", 0);
            }}
            tabIndex={0}
          />
          <label
            htmlFor="email_notification_2"
            id="email_notification_2_label"
          />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleNotificationOperationStatus("onFailure")}
        >
          Notify when backup fails
        </p>
      </div>
    </div>
  );
}

export default operationStatus;
